// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_h37","cls2":"PremiumBadge-cls2_Zgc PremiumBadge-cls1_h37"};